import { Divider } from "@redotech/redo-web/arbiter-components/divider/divider";
import { Flex } from "@redotech/redo-web/flex";
import type { ReactNode } from "react";

interface RateSourceSelectionWrapperProps {
  children: ReactNode;
}

export function RateSourceSelectionWrapper({
  children,
}: RateSourceSelectionWrapperProps) {
  return (
    <>
      <Flex my="md">
        <Divider />
      </Flex>
      <Flex dir="column" gap="md">
        {children}
      </Flex>
    </>
  );
}
